import { memo, useEffect, useMemo, useState } from 'react';
import { Button, Box, Text, Checkbox } from '@bonanza-social/moonlight';
import { Trans } from '@bonanza-social/i18n';
import { TermsAndConditionsBottomSheetProps } from './TermsAndConditions.types';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';

function TermsAndConditions({
  close,
  confirm,
  onClose,
}: TermsAndConditionsBottomSheetProps) {
  const [isChecked, setIsChecked] = useState(false);

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const eligibilityComponents = useMemo(
    () => ({
      textLink: (
        <Text
          variant="link-medium"
          onPress={() => navigation.navigate('TermsAndConditions')}
        />
      ),
    }),
    [navigation],
  );

  useEffect(() => onClose, [onClose]);

  return (
    <Box gap="space-600">
      <Text
        variant="h4"
        color="darkSurfacePrimary"
        textAlign="left"
        locNS="auth"
        locKey="termsOfUseTitle"
      />
      <Box flexDirection="row">
        <Checkbox
          flex={1}
          alignItems="flex-start"
          checked={isChecked}
          onChange={setIsChecked}
        >
          <Text variant="body-m" flexWrap="wrap" color="darkSurfacePrimary">
            <Trans
              i18nKey="termsOfUse"
              ns="auth"
              components={eligibilityComponents}
            />
          </Text>
        </Checkbox>
      </Box>
      <Button
        variant="primary"
        locNS="common"
        locKey="confirm"
        disabled={!isChecked}
        width="100%"
        onPress={() => {
          close();
          confirm();
        }}
      />
    </Box>
  );
}

export default memo(TermsAndConditions);
